export default __webpack_public_path__ + "static/media/outsystems.4f072bdc.svg";